export const DAYJS_FORMAT = {
  DATE: "YYYY/MM/DD",
  DATETIME: "YYYY/MM/DD HH:mm",
  DATE_WITH_DAY_OF_WEEK: "YYYY/MM/DD (dd)",
  DATETIME_WITH_DAY_OF_WEEK: "YYYY/MM/DD (dd) HH:mm",
};

export enum DayOfWeek {
  MONDAY = 0,
  TUESDAY = 1,
  WEDNESDAY = 2,
  THURSDAY = 3,
  FRIDAY = 4,
  SATURDAY = 5,
  SUNDAY = 6,
}

export const DAY_OF_WEEK_LABEL: {
  label: string;
  value: number;
  isDisplay: boolean;
  reservationTimes: { start: string; end: string }[];
}[] = [
  {
    label: "月",
    value: DayOfWeek.MONDAY,
    isDisplay: false,
    reservationTimes: [],
  },
  {
    label: "火",
    value: DayOfWeek.TUESDAY,
    isDisplay: false,
    reservationTimes: [],
  },
  {
    label: "水",
    value: DayOfWeek.WEDNESDAY,
    isDisplay: false,
    reservationTimes: [],
  },
  {
    label: "木",
    value: DayOfWeek.THURSDAY,
    isDisplay: false,
    reservationTimes: [],
  },
  {
    label: "金",
    value: DayOfWeek.FRIDAY,
    isDisplay: false,
    reservationTimes: [],
  },
  {
    label: "土",
    value: DayOfWeek.SATURDAY,
    isDisplay: false,
    reservationTimes: [],
  },
  {
    label: "日",
    value: DayOfWeek.SUNDAY,
    isDisplay: false,
    reservationTimes: [],
  },
];

export const RESERVATION_DAY_OF_WEEK = [
  "月",
  "火",
  "水",
  "木",
  "金",
  "土",
  "日",
];
